import forcyteService from './ForcyteService'

const BASE_URL = 'donor-portal/v2'

class AuthService {
  async login(formData) {
    return forcyteService.post(`${BASE_URL}/auth/login`, formData)
  }
  async refreshToken(formData) {
    return forcyteService.post(`${BASE_URL}/auth/refresh-token`, formData)
  }
  async logout() {
    return forcyteService.post(`${BASE_URL}/auth/logout`)
  }
  async resetPassword(formData) {
    return forcyteService.post(`${BASE_URL}/auth/reset-password`, formData)
  }
  async sendMagicLink(formData) {
    return forcyteService.post(`${BASE_URL}/auth/send-magic-link`, formData)
  }
  async requestMagicLink(formData) {
    return forcyteService.post(`${BASE_URL}/auth/request-magic-link`, formData)
  }
  async getCurrentDonor() {
    return forcyteService.get(`${BASE_URL}/auth/me`)
  }
}

const authService = new AuthService()
export default authService
